import { Component, OnInit } from '@angular/core';
import { UtilService } from '../shared/service/util/util.service';
import { RelatoriosService } from '../shared/service/relatorios/relatorios.service';
import { LoginService } from '../shared/service/login/login.service';
import { Relatorio, saveFile } from '../shared';

@Component({
    selector: 'app-historico-uso',
    templateUrl: './historico-uso.component.html',
    styleUrls: ['./historico-uso.component.css']
})
export class HistoricoUsoComponent implements OnInit {

    showSpinner: boolean = false;
    relatorio: Relatorio = new Relatorio();

    constructor(
        private loginService: LoginService,
        private utilService: UtilService,
        private relatoriosService: RelatoriosService) {

    }

    ngOnInit() {
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.relatorio.idOrganizacao = currentUser.organizacaoId;
        this.relatorio.email = currentUser.email;
        this.relatorio.nome = currentUser.nomeUsuario;
        this.relatorio.ativo = true;
        this.relatorio.excluido = false;
        this.relatorio.pendente = false;
    }

    limpar() {
        this.relatorio.dataInicio = null;
        this.relatorio.dataFim = null;
    }

    validarPeriodo(): boolean {
        let dataValidas = true;

        if ((this.relatorio.dataInicio && !this.relatorio.dataFim) || (!this.relatorio.dataInicio && this.relatorio.dataFim)) {
            this.utilService.showError("Informe a Data Inicial e a Data Final para a consulta");
            dataValidas = false;
        } else {
            if (this.relatorio.dataInicio && this.relatorio.dataFim) {
                const nmDtInicio: number = new Date(this.relatorio.dataInicio).getTime();
                const nmDtFim: number = new Date(this.relatorio.dataFim).getTime();

                if (nmDtInicio > nmDtFim) {
                    this.utilService.showError("A Data Inicial não pode ser maior que Data Final");
                    dataValidas = false;
                }
            }
        }
        return dataValidas;
    }

    gerarRelatorio() {
        let dataValidas = this.validarPeriodo();

        if (dataValidas) {
            this.showSpinner = true;
            this.relatoriosService.relatorioHistoricoUso(this.relatorio).
                then((request) => {
                    this.showSpinner = false;
                    if (request.body.size > 0) {
                        saveFile(request.body as Blob, "relatorio_historico_uso.xls");
                    } else {
                        this.utilService.showError("A consulta não retornou dados");
                    }
                }).catch(error => {
                    this.showSpinner = false;
                    if (error.status === 401 || error.status === 403) {
                        this.loginService.logout();
                    } else {
                        this.utilService.showError(error);
                    }
                });
        }
    }
}
